// @ts-nocheck
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2"
import { Select } from "semantic-ui-react";
import { api } from "services";

export const ChartLine = () => {
    const [groupBy, setGroup] = useState<any>("date");
    const [aprData, setAprData] = useState(
        {
            labels: [],
            datasets: [
                {
                    label: "APR In-game",
                    borderColor: "rgb(155 205 53)",
                    backgroundColor: "rgb(155 205 53)",
                    borderWidth: 2,
                    data: [],
                },
                {
                    label: "APR 6 Months",
                    borderColor: "rgba(159, 113, 239, 1)",
                    backgroundColor: "rgba(159, 113, 239, 1)",
                    borderWidth: 2,
                    data: [],
                },
                {
                    label: "APR 9 Months",
                    borderColor: "rgba(75,192,192,1)",
                    backgroundColor: "rgba(75,192,192,1)",
                    borderWidth: 2,
                    data: [],
                },
                {
                    label: "APR 12 Months",
                    borderColor: "rgba(250, 125, 138, 1)",
                    backgroundColor: "rgba(250, 125, 138, 1)",
                    borderWidth: 2,
                    data: [],
                },
            ]
        }
    )
    useEffect(() => {
        const loadApr = async () => {
            let rs = await api.getAprReport({
                groupBy
            });
            let groupData = rs.map((i: any) => i["_id"]["time"]);

            let newAprData = [
                {
                    label: "APR In-Game",
                    borderColor: "rgb(155 205 53)",
                    backgroundColor: "rgb(155 205 53)",
                    borderWidth: 2,
                    data: [],
                    key: "mstrAPRDaily"
                },
                {
                    label: "APR 6 Months",
                    borderColor: "rgba(159, 113, 239, 1)",
                    backgroundColor: "rgba(159, 113, 239, 1)",
                    borderWidth: 2,
                    data: [],
                    key: "periodAPRDaily_0"
                },
                {
                    label: "APR 9 Months",
                    borderColor: "rgba(75,192,192,1)",
                    backgroundColor: "rgba(75,192,192,1)",
                    borderWidth: 2,
                    key: "periodAPRDaily_1"
                },
                {
                    label: "APR 12 Months",
                    borderColor: "rgba(250, 125, 138, 1)",
                    backgroundColor: "rgba(250, 125, 138, 1)",
                    borderWidth: 2,
                    key: "periodAPRDaily_2"
                },
            ].map((item) => {
                let rate = 1;
                if (item.key === "mstrAPRDaily") {
                    rate = 100
                }
                return {
                    label: item.label,
                    borderColor: item.borderColor,
                    borderWidth: item.borderWidth,
                    backgroundColor: item.backgroundColor,
                    data: rs.map((i: any) => Math.floor(i[item.key] * 365 * 100 * rate) / 100)
                }
            })

            setAprData({
                labels: groupData,
                datasets: newAprData
            })
        }
        loadApr();
    }, [groupBy])

    return (
        <div className="bg-[#1F1D24] py-4 px-10 rounded-xl relative overflow-x-scroll" style={{
            zoom: 1.11111
        }}>
            <div className=" min-w-[400px]">
                <div className="relative h-[40px]">
                    <div className="w-[100px] right-10 absolute">
                        <label className="text-white">View by</label>
                        <Select
                            className="mt-0.5"
                            id="select-chart"
                            placeholder={"Select view time"}
                            fluid
                            value={groupBy}
                            options={["date"].map((i) => {
                                return { text: i, value: i };
                            })}
                            onChange={(evt: any, val: any) => {
                                setGroup(val.value);
                            }}
                        />
                    </div>
                    <div className="text-white text-center self-center justify-center">
                        APR Chart
                    </div>
                </div>
                <Line
                    data={aprData}
                    options={{
                        scales: {
                            yAxes: {
                                grid: {
                                    drawBorder: true,
                                    color: '#04040452',
                                },
                                ticks: {
                                    color: 'white',
                                    callback: function (value, index, values) {
                                        return value + " %";
                                      }
                                }
                            },
                            xAxes: {
                                grid: {
                                    drawBorder: true,
                                    color: '#04040452',
                                },
                                ticks: {
                                    color: 'white',
                                }
                            },
                        },
                        responsive: true,
                        plugins: {
                            legend: {
                                position: 'top' as const,
                            },
                            tooltip: {
                                callbacks: {
                                    label: function(context) {
                                        var label = context.dataset.label || '';
                                        if (context.parsed.y !== null) {
                                            label += ' ' + context.parsed.y + '%';
                                        }
                                        return label;
                                    }
                                }
                            }
                        },
                    }}
                />
            </div>
        </div>
    )
}